import { ReportCandidateReasonModel, IReportCandidateReason } from "@core/models";

export const reportCandidateReasonMock = [
  {
    [IReportCandidateReason.id]: "0123",
    [IReportCandidateReason.label]: "not_attended",
  },
  {
    [IReportCandidateReason.id]: "0124",
    [IReportCandidateReason.label]: "not_attended_first_day",
  },
  {
    [IReportCandidateReason.id]: "0125",
    [IReportCandidateReason.label]: "other",
  },
].map((reason) => new ReportCandidateReasonModel(reason));
